import React, { useContext, useEffect, useState } from 'react'
import LogsComponent from '../../../../components/Logs/LogsComponent'
import {
  Avatar,
  Box,
  Button,
  Chip,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import SendIcon from '@mui/icons-material/Send'
import API from '../../../../services/API'
import { UserContext } from '../../../../App'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import UpgradeRequired from '../../../../components/Upgrade/UpgradeGate'
import UpgradeRequiredPage from '../../../../components/Subscriptions/UpgradeRequiredPage'
import SubscriptionGate from '../../../../components/Subscriptions/SubscriptionGate'

// TODO: Toggle Visibility, Allow Deletiong

const Log = ({ log }) => {
  const [showInRecord, setShowInRecord] = useState(log?.showInRecord || false)
  const [loadingChange, setLoadingChange] = useState(false)
  const handleEditVisibility = () => {
    setLoadingChange(true)
    API.put('/epcr-clinicaladvice', {
      _id: log._id,
      showInRecord: !!!log?.showInRecord,
    })
      .then(
        (res) => res.status === 200 && setShowInRecord(!!!log?.showInRecord),
      )
      .finally(() => setLoadingChange(false))
  }
  return (
    <Stack
      direction="row"
      gap={1}
      padding={1}
      sx={{ borderTop: 'solid 1px grey' }}
    >
      <Stack alignItems="center" gap={1}>
        <Avatar
          src={log?.person?.photograph}
          sx={{ borderRadius: 1, width: 30, height: 30 }}
        />
        <Tooltip
          title={`Log is ${showInRecord ? 'visible' : 'hidden'} in record`}
        >
          <IconButton
            onClick={() => {
              !loadingChange && handleEditVisibility()
            }}
          >
            {showInRecord ? (
              <VisibilityIcon color="error" />
            ) : (
              <VisibilityOffIcon color="info" />
            )}
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="title2" fontSize="1rem">
          {log?.person?.firstName} {log?.person?.lastName}
        </Typography>
        <Typography variant="caption">
          {moment(log?.createdAt).format('DD/MM/YYYY HH:mm').toString()}
        </Typography>
        {/* pre-wrap keeps the author's line breaks (e.g. SBAR layout) */}
        <Typography sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
          {log.note}
        </Typography>
      </Stack>
    </Stack>
  )
}

const ClinicalAdviceLine = ({
  epcrID,
  calNotes,
  setCALNotes,
  currentTreatmentLocation,
}) => {
  const [newNote, setNewNote] = useState('')
  const [showInRecord, setShowInRecord] = useState(true)

  const { user } = useContext(UserContext)
  const heldByTreatmentLocation = !!currentTreatmentLocation

  useEffect(() => {
    if (!epcrID) {
      return
    }
    API.get(`/epcr/clinicaladvice/${epcrID}`).then((res) => {
      if (res.status === 200) {
        setCALNotes?.(res.data)
      }
    })
  }, [epcrID])

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/epcr/clinicaladvice', {
      epcr: epcrID,
      note: newNote,
      showInRecord,
    }).then((res) => {
      if (res.status === 200) {
        setCALNotes?.((prev) => [
          {
            person: {
              firstName: user.firstName,
              lastName: user.lastName,
              photograph: user.photograph,
            },
            note: newNote,
            showInRecord,
            createdAt: moment(),
            _id: moment().unix(),
          },
          ...prev,
        ])
        setNewNote('')
        setShowInRecord(true)
      }
    })
  }
  return (
    <DetailsBox
      title="Clinical Advice, Governance & Safeguarding Notes"
      withBorder
    >
      <SubscriptionGate inline requiredTier={2} featureName="Clinical Advice">
        {heldByTreatmentLocation && (
          <Chip
            color="info"
            label={`Held by ${currentTreatmentLocation?.name || 'treatment centre'}`}
            sx={{ alignSelf: 'flex-start', borderRadius: 1 }}
          />
        )}
        {user?.employee?.teams?.includes('Governance') &&
          !heldByTreatmentLocation && (
          <Stack
            direction={{ xs: 'column', lg: 'row' }}
            gap={1}
            component="form"
            onSubmit={handleSubmit}
          >
            <TextField
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              multiline
              minRows={2}
              placeholder="Add a New Note"
              fullWidth
              required
            />
            <Stack alignItems="center">
              <Typography variant="caption" textAlign="center">
                Show in Record
              </Typography>
              <Switch
                onChange={(e) => setShowInRecord(e.target.checked)}
                checked={showInRecord}
              />
            </Stack>
            <Button
              variant="contained"
              color="success"
              type="submit"
              endIcon={<SendIcon />}
            >
              Submit
            </Button>
          </Stack>
        )}
        <Stack gap={1} marginTop={5}>
          {calNotes &&
            calNotes.map((note) => <Log log={note} key={note?._id} />)}
        </Stack>
      </SubscriptionGate>
    </DetailsBox>
  )
}

export default ClinicalAdviceLine
